import React from "react";
import { Spinner } from "react-bootstrap";
import { GenericChart, dollarFormatter } from "../../../../shared";
import { PERCENTAGE_FORMAT_CONSTANTS } from "../../../../constants";
import {
  emptyString,
  marketingSalesChartLabelConstants,
  MARKETING_SALES_CHART,
  MARKETING_SALES_EMPTY_CHART,
  MARKETING_SALES_CHART_OPTIONS,
} from "../../constants";

const {
  TYPE,
  SALES,
  ORDERS,
  TOTAL,
  NON_MARKETING_SALES,
  NON_MARKETING_ORDERS,
  CAMPAIGN_CONVERSION_RATE,
  MARKETING_GENERATED_SALES,
  MARKETING_ATTRIBUTED_ORDERS,
  CAMPAIGN_CONVERSION_RATE_DESCRIPTION,
} = marketingSalesChartLabelConstants;

const formatCount = (count) => count;

// Give Sales and Orders the same card layout and zero-data fallback.
const SalesOrdersCard = ({
  title,
  secondaryTitle,
  primaryValue,
  secondaryValue,
  chartData,
  formatValue = formatCount,
}) => (
  <div className="col-8 col-lg-3 card mb-2 mb-md-0 px-0 mt-2">
    <div className="text-center pb-2 pt-2 px-2">
      <p className="fw-bold">{title}</p>
      <hr />
      <p className="fw-bold mb-0">{formatValue(primaryValue)}</p>
    </div>
    <div className="w-100 px-2">
      <GenericChart
        className="d-flex justify-content-center"
        chartType={MARKETING_SALES_CHART.TYPE}
        width={MARKETING_SALES_CHART.WIDTH}
        height={MARKETING_SALES_CHART.HEIGHT}
        data={primaryValue && secondaryValue ? chartData : MARKETING_SALES_EMPTY_CHART}
        options={MARKETING_SALES_CHART_OPTIONS}
      />
    </div>
    <div className="text-center pb-2 pt-0 px-2">
      <p className="fw-bold align-end mt-3 mb-1">{secondaryTitle}</p>
      <hr />
      <p className="fw-bold mb-0 align-end">{formatValue(secondaryValue)}</p>
    </div>
    <div className="pb-0 pt-2 marketing-total-count">
      <p className="fw-bold text-center mb-0 mt-3">{TOTAL}</p>
      <p className="fw-bold text-center">{formatValue(primaryValue + secondaryValue)}</p>
    </div>
  </div>
);

const MultiCharts = ({
  salesReport,
  isSpinnerRunning,
  totalSmsDelivered,
  totalEmailDelivered,
}) => {
  const marketingGeneratedSales = salesReport?.marketingGeneratedSales || 0;
  const totalSales = salesReport?.untargetedSales || 0;
  const marketingOrders = salesReport?.totalRestaurantMarketingOrders;
  const restaurantOrders = salesReport?.totalRestaurantOrders;
  const totalDelivered = totalSmsDelivered + totalEmailDelivered;

  // Recalculate from current report data and keep invalid rates out of the page.
  const rate = totalDelivered === 0
    ? 0
    : (marketingOrders / totalDelivered) * PERCENTAGE_FORMAT_CONSTANTS.MULTIPLIER;
  const conversionRate = Number.isNaN(rate) || !Number.isFinite(rate)
    ? 0
    : Math.floor(rate);
  const salesData = [
    [TYPE, SALES],
    [NON_MARKETING_SALES, totalSales],
    [MARKETING_GENERATED_SALES, marketingGeneratedSales],
  ];
  const ordersData = [
    [TYPE, ORDERS],
    [NON_MARKETING_ORDERS, restaurantOrders || emptyString],
    [MARKETING_ATTRIBUTED_ORDERS, marketingOrders || emptyString],
  ];

  return (
    <div className="row d-flex justify-content-evenly pt-2 mx-0">
      <SalesOrdersCard
        title={MARKETING_GENERATED_SALES}
        secondaryTitle={NON_MARKETING_SALES}
        primaryValue={marketingGeneratedSales}
        secondaryValue={totalSales}
        chartData={salesData}
        formatValue={dollarFormatter.format}
      />
      <SalesOrdersCard
        title={MARKETING_ATTRIBUTED_ORDERS}
        secondaryTitle={NON_MARKETING_ORDERS}
        primaryValue={marketingOrders}
        secondaryValue={restaurantOrders}
        chartData={ordersData}
      />
      <div className="col-8 col-lg-3 card px-2 pb-0 pt-2 mt-2 text-center">
        <p className="fw-bold mb-0">{CAMPAIGN_CONVERSION_RATE}</p>
        <hr />
        <p className="font-size-xxxs">{CAMPAIGN_CONVERSION_RATE_DESCRIPTION}</p>
        <div className="align-value-center">
          {isSpinnerRunning ? (
            <Spinner animation="border" role="status" />
          ) : (
            <h1>{conversionRate}%</h1>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiCharts;
